import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import isNotEmptyReactElementContent from 'core/utils/content';

import styles from './index.styl';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

/**
 * @author Pavel Povalyaev <p.povalyaev@rambler-co.ru>
 */

function Text(props) {
  const {
    children,
    theme: {
      texts: { body },
      controls: { mark },
    },
    className,
  } = props;

  const letterSpacing = body.letterSpacing;
  const scope = letterSpacing
    ? resolveScopedStyles(
      <scope>
        <style jsx>{`
          .letterSpacing
            letter-spacing ${letterSpacing}
        `}</style>
      </scope>
    ) : null;

  if (isNotEmptyReactElementContent(children)) {
    return (
      <div
        className={cx(
          'text',
          styles.text,
          scope && scope.wrapClassNames('letterSpacing'),
          className,
        )}
        data-qa='text'
      >
        <style jsx>{`
          .text
            font ${body.font}
            color ${body.color}

            :global(mark)
              -webkit-box-decoration-break clone
              box-decoration-break clone
              color ${mark.color}
              padding ${mark.padding}
              background ${mark.background}

            :global(mark a)
              color ${mark.color}
              &:visited
              &:hover
                color inherit
        `}</style>
        {children}
        {letterSpacing && <scope.styles />}
      </div>
    );
  }
  return null;
}

Text.propTypes = {
  /** Контент блока */
  children: PropTypes.node,
  /** Класс для кастомизации блока с текстом */
  className: PropTypes.string,
  /** @ignore */
  theme: themePropTypes(`
    {
      texts: {
        body: {
          font,
          color
        }
      },
      controls: {
        mark: {
          color,
          padding,
          background
        }
      }
    }
  `),
};

const TextWithHOCs = withTheme(Text);
TextWithHOCs.displayName = 'Text';

export { Text as StorybookComponent };
export default TextWithHOCs;
